import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import PCLNPopover from 'pcln-popover'
import DropdownContent from '../DropdownContent'

const StyledPopover = styled(PCLNPopover)`
  & > section {
    box-shadow: none;
  }

  & > span {
    color: ${props => props.backgroundColor || 'background.lightest'};

    &::before {
      border-color: ${props => props.backgroundColor || 'background.lightest'}
        ${props => props.backgroundColor || 'background.lightest'} transparent
        transparent !important;
      box-shadow: none !important;
    }
  }
`

function DropdownPopover ({
  id,
  className,
  backgroundColor,
  content,
  children
}) {
  return (
    <StyledPopover
      idx={id}
      className={className}
      renderContent={() => (
        <DropdownContent backgroundColor={backgroundColor}>
          {content}
        </DropdownContent>
      )}
      placement='bottom'
      zIndex={110}
      backgroundColor={backgroundColor}
      width={300}
    >
      {children}
    </StyledPopover>
  )
}

DropdownPopover.displayName = 'DropdownPopover'

DropdownPopover.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  backgroundColor: PropTypes.string,
  content: PropTypes.node,
  children: PropTypes.node
}

DropdownPopover.defaultProps = {
  className: ''
}

export default memo(DropdownPopover)
